<div class="desktop">
  <div class="subheader" style="margin-bottom: 1rem;">
    <ng-container i18n>Contact Property</ng-container>
  </div>
  <div class="flex">
    <a [@fadeIn] class="contact-btn" style="margin-right: 16px;" href="tel:{{hostel?.phone?.country_code}}{{hostel?.phone?.number}}">
      <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/phone.svg"></svg-icon>
      <span>Phone</span>
      <span>+{{hostel?.phone?.country_code}}&nbsp;{{hostel?.phone?.number}}</span>
    </a>
    <a [@fadeIn] class="contact-btn" href="mailto:{{hostel?.email}}">
      <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/email.svg"></svg-icon>
      <span>Email</span>
      <span>{{hostel?.email}}</span>
    </a>
  </div>
</div>

<div class="mobile">
  <h3>
    <ng-container i18n>Contact Property</ng-container>
  </h3>
  <div class="button-wrapper">
    <div class="flex between phone_email">
      <a [@fadeIn] class="btn btn-light btn-large" href="tel:{{hostel?.phone?.country_code}}{{hostel?.phone?.number}}">
        <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/phone.svg"></svg-icon>
        <span>Call hostel</span>
      </a>
      <a [@fadeIn] class="btn btn-light btn-large" href="mailto:{{hostel?.email}}">
        <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/email.svg"></svg-icon>
        <span>Email hostel</span>
      </a>
    </div>
  </div>
  <div class="button-wrapper">
    <button [@fadeIn] class="btn btn-light btn-large">
      <svg-icon [svgStyle]="{'width.px': 25}" src="/assets/icons/globe.svg"></svg-icon>
      <span>View Website</span>
    </button>
  </div>
  <div class="button-wrapper">
    <button [@fadeIn] class="btn btn-dark btn-large">
      <svg-icon class="social" [svgStyle]="{'width.px': 25}" src="/assets/icons/instagram.svg"></svg-icon>
      <span>View on Instagram</span>
    </button>
  </div>
  <div class="button-wrapper">
    <button [@fadeIn] class="btn btn-dark btn-large">
      <svg-icon class="social" [svgStyle]="{'width.px': 25}" src="/assets/icons/facebook.svg"></svg-icon>
      <span>View on Facebook</span>
    </button>
  </div>
</div>
